import React from 'react'
import fishimage from "./fish.svg"
export const Fish = () => {
    return (
        <div class="wrapper">
            <div class="content">
                <div class="swim fish">

                    <img src={fishimage} alt="fish" />
                </div>
            </div>
        </div>

    )
}
